import { getLocale } from 'i18n';
import { tr } from 'i18n';
import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import React, { useState } from 'react'
import styles from './DocumentView.module.scss'
import { addComment, deleteComment } from '../../../../service/DocflowService'

function fmtDate(str) {
  if (!str) return ''
  const d = new Date(str)
  if (isNaN(d.getTime())) return str
  return d.toLocaleString(getLocale(), { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
}

export default function DocComments({ docId, comments: initComments = [], onCommentsChange }) {
  useInterfaceLanguage();
  const [comments, setComments] = useState(initComments)
  const [text, setText]         = useState('')
  const [loading, setLoading]   = useState(false)

  async function handleAdd(e) {
    e.preventDefault()
    if (!text.trim()) return
    setLoading(true)
    try {
      const r = await addComment(docId, text.trim())
      const updated = [...comments, r.data]
      setComments(updated)
      onCommentsChange?.(updated)
      setText('')
    } finally { setLoading(false) }
  }

  async function handleDelete(id) {
    await deleteComment(id)
    const updated = comments.filter(c => c.id !== id)
    setComments(updated)
    onCommentsChange?.(updated)
  }

  return (
    <div className={styles.commentsSection}>
      <h3 className={styles.panelSectionTitle}>{tr("Комментарии")}{tr(comments.length > 0 && (
          <span className={styles.commentCount}>{tr(comments.length)}</span>
        ))}
      </h3>

      {tr(comments.length === 0 && (
        <p className={styles.emptySub}>{tr("Комментариев ещё нет")}</p>
      ))}

      <div className={styles.commentsList}>
        {comments.map(c => (
          <div key={c.id} className={`${styles.commentItem} ${c.is_mine ? styles.commentMine : ''}`}>
            <div className={styles.commentHeader}>
              <div className={styles.commentInfo}>
                <span className={styles.commentAuthor}>{tr(c.employee_name)}</span>
                {tr(c.employee_dept && <span className={styles.commentDept}>{tr(c.employee_dept)}</span>)}
              </div>
              <div className={styles.commentActions}>
                <span className={styles.commentDate}>{fmtDate(c.created_at)}</span>
                {tr(c.is_mine && (
                  <button
                    className={styles.deleteCommentBtn}
                    onClick={() => handleDelete(c.id)}
                    title={tr("Удалить")}
                  >
                    ×
                  </button>
                ))}
              </div>
            </div>
            <p className={styles.commentText}>{tr(c.text)}</p>
          </div>
        ))}
      </div>

      <form className={styles.commentForm} onSubmit={handleAdd}>
        <textarea
          className={styles.commentInput}
          value={text}
          onChange={e => setText(e.target.value)}
          placeholder={tr("Написать комментарий…")}
          rows={2}
          onKeyDown={e => {
            if (e.key === 'Enter' && (e.ctrlKey || e.metaKey)) handleAdd(e)
          }}
        />
        <button
          type="submit"
          className={styles.sendCommentBtn}
          disabled={loading || !text.trim()}
        >
          {loading ? '…' : '➤'}
        </button>
      </form>
    </div>
  )
}
